import { useState } from 'react'

import { ru, vernier } from '../../lib/physics'
import { Predict, Slider } from './common'

/**
 * Нониус (урок 4): десять делений нониуса равны девяти делениям основной шкалы. Двигая
 * нониус, ученик видит, что совпадает то один, то другой штрих, — номер совпавшего штриха
 * и есть десятые доли миллиметра. Так штангенциркуль меряет точнее половины своего деления.
 */

const PX = 9 // пикселей на миллиметр
const X0 = 20
const MM = 36 // длина основной шкалы на рисунке

export default function VernierLab() {
  const [x, setX] = useState(11.5)
  const отсчёт = vernier(x)
  const нониус = X0 + x * PX // где ноль нониуса

  return (
    <div className="card">
      <svg className="lab-svg" viewBox="0 0 360 150" role="img" aria-label="Основная шкала и нониус">
        {/* губки штангенциркуля: между ними ручка */}
        <rect x={X0 - 6} y={10} width={6} height={50} className="fill-muted" />
        <rect x={нониус} y={10} width={6} height={50} className="fill-muted" />
        <rect x={X0} y={24} width={x * PX} height={22} rx={6} className="fill-heavy" opacity={0.6} />
        {/* основная шкала, мм */}
        <rect x={X0 - 6} y={62} width={MM * PX + 12} height={30} className="fill-ruler ink" strokeWidth={1} />
        {Array.from({ length: MM + 1 }, (_, i) => (
          <g key={i}>
            <line x1={X0 + i * PX} y1={92} x2={X0 + i * PX} y2={i % 10 === 0 ? 70 : i % 5 === 0 ? 76 : 82} className="ink" strokeWidth={0.8} />
            {i % 10 === 0 && <text x={X0 + i * PX} y={68} textAnchor="middle" className="lab-tick">{i / 10}</text>}
          </g>
        ))}
        <text x={X0 + MM * PX} y={58} textAnchor="end" className="lab-tick">см</text>
        {/* нониус: 10 делений по 0,9 мм */}
        <rect x={нониус - 4} y={92} width={9 * PX + 8} height={28} className="fill-cabin ink" strokeWidth={1} />
        {Array.from({ length: 11 }, (_, i) => {
          const xi = нониус + i * 0.9 * PX
          const совпал = i === отсчёт.штрих
          return (
            <g key={i}>
              <line x1={xi} y1={92} x2={xi} y2={i % 5 === 0 ? 106 : 100} className={совпал ? 'ink-el' : 'ink'} strokeWidth={совпал ? 2.4 : 0.8} />
              {i % 5 === 0 && <text x={xi} y={116} textAnchor="middle" className="lab-tick">{i}</text>}
            </g>
          )
        })}
        <line x1={нониус + отсчёт.штрих * 0.9 * PX} y1={62} x2={нониус + отсчёт.штрих * 0.9 * PX} y2={92} className="ink-el" strokeWidth={1.6} strokeDasharray="3 2" />
      </svg>

      <div className="lab-readout">
        <span>ноль нониуса правее отметки <b>{отсчёт.целых} мм</b></span>
        <span className="el">совпал штрих нониуса <b>№ {отсчёт.штрих}</b></span>
        <span>размер = {отсчёт.целых} + {отсчёт.штрих}·0,1 = <b>{ru(отсчёт.отсчёт, 1)} мм</b></span>
      </div>

      <Slider label="Раздвинь губки" value={x} min={0} max={25} step={0.1} unit="мм" shown={ru(x, 1)} onChange={setX} />

      <Predict
        question="Ноль нониуса чуть правее отметки 11 мм, совпал пятый штрих. Каков размер?"
        options={['11 мм', '11,5 мм', '16 мм']}
        right={1}
        revealed={Math.abs(x - 11.5) < 0.05}
        explain="Целые миллиметры — по нулю нониуса, десятые — по номеру совпавшего штриха: 11 + 0,5 = 11,5 мм. Так в уроке измерили толщину ручки."
      />
      <p className="muted small">
        Каждое деление нониуса на 0,1 мм короче миллиметра. Сдвинул нониус на 0,1 мм — совпал
        первый штрих, на 0,2 мм — второй. Цена деления линейки 1 мм, а штангенциркуль меряет до 0,1 мм.
      </p>
    </div>
  )
}
